const administrationData = {
    filters: {

    },
    data() {
        return {
            newPushnotification: {},
            snackbar: {
                color: null,
                visible: false,
                title: null,
                message: null
            },
        }
    },
    computed: {
        emailResended() {
            return this.$store.getters.emailResended;
        },
        userInformations() {
            return this.$store.getters.userInformations;
        },
        clients() {
            return this.$store.getters.clients;
        },
        updatingClients() {
            return this.$store.getters.updatingClients;
        },
        clientEvents() {
            return this.$store.getters.clientEvents;
        },
        clientEventNotifications() {
            return this.$store.getters.clientEventNotifications;
        },
        unapprovedEvents() {
            return this.$store.getters.unapprovedEvents;
        },
        updatingUnapprovedEvents() {
            return this.$store.getters.updatingUnapprovedEvents;
        },
        clientEventEntries() {
            return this.$store.getters.clientEventEntries;
        },
        clientEventInvoices() {
            return this.$store.getters.clientEventInvoices;
        },
        updatingClientEvents() {
            return this.$store.getters.updatingClientEvents;
        },
        updatingClientInvoices() {
            return this.$store.getters.updatingClientInvoices;
        },
        selectedClientEvent() {
            return this.$store.getters.selectedClientEvent;
        },
        getYears() {
            let years = [];
            const thisYear = new Date().getFullYear();
            const startYear = 2021;
            const futureYears = 5; // Next 5 years for future events

            // From 2021 to current year + 5 years
            for (let index = startYear; index <= thisYear + futureYears; index++) {
                years.push(index);
            }
            return years;
        },
        currentYear() {
            var now = new Date();
            return now.getFullYear();
        },
        selectedYear() {
            return this.$store.getters.selectedYear;
        },
    },

    mounted() {

    },

    methods: {
        csvExportEntries(event, evententries) {
            // Include entries from linked event if available in admin store
            let arrData = Array.isArray(evententries) ? [...evententries] : []
            if (event && event.linkedEvent && Array.isArray(this.clientEvents)) {
                const linkedId = typeof event.linkedEvent === 'object' ? event.linkedEvent._id : event.linkedEvent
                const linkedEvent = this.clientEvents.find(e => e && e._id == linkedId)
                if (linkedEvent && Array.isArray(linkedEvent.entries)) {
                    arrData = arrData.concat(linkedEvent.entries)
                }
            }
            let csvData = []
            arrData.forEach(element => {
                // Determine payment method
                const payment = element.payment_id && element.payment_id[0]
                let paymentMethodLabel = "PayPal"
                if (payment) {
                    if (payment.payment_method === 'pos') {
                        // POS payment - check payment_mode for specific type
                        switch (payment.payment_mode) {
                            case 'cash':
                                paymentMethodLabel = "POS: Bar"
                                break
                            case 'electronic':
                                paymentMethodLabel = "POS: Elektronisch"
                                break
                            case 'invoice':
                                paymentMethodLabel = "POS: Rechnung"
                                break
                            default:
                                paymentMethodLabel = "POS: Unbekannt"
                        }
                    } else {
                        paymentMethodLabel = "PayPal"
                    }
                }
                
                // Get transaction ID (PayPal) or payment_id (POS)
                let transactionId = ""
                if (payment) {
                    transactionId = payment.payment_id || (payment.transactions && payment.transactions[0] && payment.transactions[0].related_resources && payment.transactions[0].related_resources[0] && payment.transactions[0].related_resources[0].sale && payment.transactions[0].related_resources[0].sale.id) || ""
                }
                
                // Determine ticket price (custom price for POS or regular price)
                let ticketPrice = element.customPrice || (element.participant_data && element.participant_data.price_lowered ? event.price_lowered : event.price)
                let ticketPriceStr = ticketPrice ? ticketPrice.toFixed(2).replace(".", ",") : "0,00"
                
                let entryData = {
                    "Eventname": event.title,
                    "Rechnungsnummer": payment ? payment.invoice_nr : "",
                    "Ticketpersonalisierung": element.participant_data ? element.participant_data.name : "",
                    "Nachname": element.lastname,
                    "Vorname": element.firstname,
                    "Straße": element.street,
                    "PLZ": element.zip ? element.zip.toString() : "",
                    "E-Mail": element.email,
                    "Scanner-Code (Ticket-ID)": element._id,
                    "Rechnungsdatum": payment ? payment.update_time : "",
                    "Zahlungsart": paymentMethodLabel,
                    "Zahlungs-ID": transactionId,
                    "Ticketpreis in EUR": ticketPriceStr,
                    "Ermäßigt": (element.participant_data && element.participant_data.price_lowered) ? "Ja" : "Nein",
                    "Ticket eingelöst": element.redeemed ? "Ja" : "Nein",
                    "Zeitstempel einlösung": element.redeemed ? element.updated : "n/a"
                }

                csvData.push(entryData)
            })

            // arrData = JSON.parse(JSON.stringify(arrData))
            arrData.forEach(element => {
                if (element.redeemed == undefined) {
                    element.redeemed = false
                }
                delete element.participants;
                delete element.participant_data;
                delete element.edit;
                delete element._id;
                delete element.event;
                delete element.dsgvo_accepted;
                delete element.__v;
                delete element.updated;
            })
            let csvContent = "data:text/csv;charset=utf-8,";
            csvContent += [
                Object.keys(csvData[0]).join(";"),
                ...csvData.map(item => Object.values(item).join(";"))
            ]
                .join("\n")
                .replace(/(^\[)|(\]$)/gm, "");

            const data = encodeURI(csvContent);
            const link = document.createElement("a");
            link.setAttribute("href", data);
            link.setAttribute("download", event.url + "_export.csv");
            link.click();
        },
        csvExportCodes(event, evententries, includeAll) {
            // Combine current entries with linked event entries (if provided/available)
            let entries = Array.isArray(evententries) ? evententries : []
            if (event && event.linkedEvent) {
                const linkedId = typeof event.linkedEvent === 'object' ? event.linkedEvent._id : event.linkedEvent
                const linkedEvent = this.clientEvents && this.clientEvents.find(e => e && e._id == linkedId)
                if (linkedEvent && Array.isArray(linkedEvent.entries)) {
                    entries = entries.concat(linkedEvent.entries)
                }
            }

            const filtered = (includeAll ? entries : entries.filter(el => el && el.email_verified === true && el.canceled !== true))
            const codes = Array.from(new Set(filtered.map(el => el && el._id).filter(Boolean)))

            let csvContent = "data:text/csv;charset=utf-8,"
            const header = ["Scanner-Code (Ticket-ID)"]
            const rows = codes.map(code => [code])
            csvContent += [
                header.join(";"),
                ...rows.map(r => r.join(";"))
            ]
                .join("\n")
                .replace(/(^\[)|(\]$)/gm, "")

            const data = encodeURI(csvContent)
            const link = document.createElement("a")
            link.setAttribute("href", data)
            const suffix = includeAll ? "_codes_alle.csv" : "_codes.csv"
            link.setAttribute("download", (event.url || event.title || 'event') + suffix)
            link.click()
        },
        csvExportYear(invoices, year, client) {
            console.log(invoices, year, client)
            let csvData = [];
            const groupedByInvoice = new Map();

            invoices.forEach(element => {
                try {
                    // Wenn diese Rechnung storniert wurde und eine Stornorechnung existiert, überspringen
                    // (entfernt, damit auch ursprüngliche Rechnungen mit Stornorechnung aufgenommen werden)

                    const invoiceNr = element.invoice_nr || "UNBEKANNT";
                    
                    // Determine payment method label
                    let paymentMethodLabel = "PayPal";
                    if (element.payment_method === 'pos') {
                        // POS payment - check payment_mode for specific type
                        switch (element.payment_mode) {
                            case 'cash':
                                paymentMethodLabel = "POS: Bar";
                                break;
                            case 'electronic':
                                paymentMethodLabel = "POS: Elektronisch";
                                break;
                            case 'invoice':
                                paymentMethodLabel = "POS: Rechnung";
                                break;
                            default:
                                paymentMethodLabel = "POS: Unbekannt";
                        }
                    } else {
                        paymentMethodLabel = "PayPal";
                    }
                    
                    // Get transaction ID (PayPal) or payment_id (POS)
                    const transactionId = element.payment_id || element?.transactions[0]?.related_resources[0]?.sale?.id || "";
                    
                    const entryData = {
                        "Eventname": element.event?.title,
                        "Rechnungsnummer": invoiceNr,
                        "Rechnungsdatum": element.update_time,
                        "Nachname": element.eventPayload.lastname.replace('#', ''),
                        "Vorname": element.eventPayload.firstname.replace('#', ''),
                        "Straße": element.eventPayload.street.replace('#', 'n'),
                        "PLZ": element.eventPayload.zip.replace('#', ''),
                        "E-Mail": element.eventPayload.email.replace('#', ''),
                        "Zahlungsart": paymentMethodLabel,
                        "Zahlungs-ID": transactionId,
                        "Mehrwertsteuer in %": element.event.vat_value,
                        "Gesamtpreis in EUR": element.transactions[0].amount.total.toString().replace('.', ','),
                        "Status": element.canceled ? "STORNIERT" : "AKTIV",
                        "Storno-Betrag in EUR": element.cancelation_invoice ? `-${element.transactions[0].amount.total.toString().replace('.', ',')}` : ""
                    };

                    if (!groupedByInvoice.has(invoiceNr)) {
                        groupedByInvoice.set(invoiceNr, []);
                    }
                    groupedByInvoice.get(invoiceNr).push(entryData);
                } catch (error) {
                    console.log('error on push:', error)
                }
            });

            // Reihenfolge nach Rechnungsnummer
            const sortedInvoiceGroups = Array.from(groupedByInvoice.entries()).sort((a, b) => {
                return a[0].localeCompare(b[0]);
            });

            // Daten gruppiert in csvData schreiben
            sortedInvoiceGroups.forEach(([invoiceNr, entries]) => {
                csvData.push(...entries);
            });

            // Summen je Event vorbereiten
            const grouped = {};

            csvData.forEach(row => {
                const event = row["Eventname"] || "Unbekannt";
                const preis = parseFloat(row["Gesamtpreis in EUR"].replace(',', '.')) || 0;
                const storno = row["Storno-Betrag in EUR"] ? parseFloat(row["Storno-Betrag in EUR"].replace(',', '.')) : 0;

                if (!grouped[event]) {
                    grouped[event] = { brutto: 0, storno: 0 };
                }

                grouped[event].brutto += preis;
                grouped[event].storno += storno;
            });

            // Gesamtsummen
            let gesamtBrutto = 0;
            let gesamtStorno = 0;

            // Trennzeile vor den Summen je Event
            csvData.push({
                "Eventname": "–––––––––––––––––––––––––––––––––––––––––––––––––––––––",
                "Rechnungsnummer": "",
                "Rechnungsdatum": "",
                "Nachname": "",
                "Vorname": "",
                "Straße": "",
                "PLZ": "",
                "E-Mail": "",
                "Zahlungsart": "",
                "Zahlungs-ID": "",
                "Mehrwertsteuer in %": "",
                "Gesamtpreis in EUR": "",
                "Status": "",
                "Storno-Betrag in EUR": ""
            });

            Object.keys(grouped).forEach(event => {
                gesamtBrutto += grouped[event].brutto;
                gesamtStorno += grouped[event].storno;

                csvData.push({
                    "Eventname": event,
                    "Rechnungsnummer": "",
                    "Rechnungsdatum": "",
                    "Nachname": "",
                    "Vorname": "",
                    "Straße": "",
                    "PLZ": "",
                    "E-Mail": "",
                    "Zahlungsart": "",
                    "Zahlungs-ID": "",
                    "Mehrwertsteuer in %": "",
                    "Gesamtpreis in EUR": grouped[event].brutto.toFixed(2).replace('.', ','),
                    "Status": "SUMME EVENT",
                    "Storno-Betrag in EUR": grouped[event].storno.toFixed(2).replace('.', ',')
                });
            });

            const saldoGesamt = gesamtBrutto + gesamtStorno;

            // Gesamtsummen-Zeile
            csvData.push({
                "Eventname": "GESAMT",
                "Rechnungsnummer": "",
                "Rechnungsdatum": "",
                "Nachname": "",
                "Vorname": "",
                "Straße": "",
                "PLZ": "",
                "E-Mail": "",
                "Zahlungsart": "",
                "Zahlungs-ID": "",
                "Mehrwertsteuer in %": "",
                "Gesamtpreis in EUR": gesamtBrutto.toFixed(2).replace('.', ','),
                "Status": "SUMME GESAMT",
                "Storno-Betrag in EUR": gesamtStorno.toFixed(2).replace('.', ',')
            });

            csvData.push({
                "Eventname": "SALDO",
                "Rechnungsnummer": "",
                "Rechnungsdatum": "",
                "Nachname": "",
                "Vorname": "",
                "Straße": "",
                "PLZ": "",
                "E-Mail": "",
                "Zahlungsart": "",
                "Zahlungs-ID": "",
                "Mehrwertsteuer in %": "",
                "Gesamtpreis in EUR": saldoGesamt.toFixed(2).replace('.', ','),
                "Status": "EFFEKTIV",
                "Storno-Betrag in EUR": ""
            });

            let csvContent = "data:text/csv;charset=utf-8,";

            csvContent += [
                Object.keys(csvData[0]).join(";"),
                ...csvData.map(item => Object.values(item).join(";"))
            ]
                .join("\n")
                .replace(/(^\[)|(\]$)/gm, "");

            console.log(csvContent)
            const data = encodeURI(csvContent);
            const link = document.createElement("a");
            link.setAttribute("href", data);
            link.setAttribute("download", year + "_" + client.companyName + "_export.csv");
            link.click();
        },
        downloadInvoice(invoice) {
            this.$store.dispatch("downloadInvoice", invoice);
        },
        getPaypalState(state) {
            switch (state) {
                case "completed":
                    return "ABGESCHLOSSEN";
                case "refunded":
                    return "ERSTATTET";
                default:
                    return state;
            }
        },
        resendEmail(eventEntry) {
            this.$store.dispatch("resendEmail", eventEntry);
        },
        updateEventEntry(eventEntry) {
            console.log(eventEntry)
            this.$store.dispatch("updateEventEntry", eventEntry);
            // this.$store.dispatch("getEventEntries");
        },
        getImage(link) {
            return process.env.VUE_APP_API_BASEURL + '/' + link
        },
        SnackbarShow(type, title, message) {
            if (!type) return;
            switch (type) {
                case "Info":
                    this.snackbar = {
                        color: "#1A73E8",
                        visible: true,
                        title: title,
                        message: message
                    };
                    break;
                case "Success":
                    this.snackbar = {
                        color: "#4CAF50",
                        visible: true,
                        title: title,
                        message: message
                    };
                    break;
                case "Warning":
                    this.snackbar = {
                        color: "#fb8c00",
                        visible: true,
                        title: title,
                        message: message
                    };
                    break;
                case "Danger":
                    this.snackbar = {
                        color: "#F44335",
                        visible: true,
                        title: title,
                        message: message
                    };
                    break;
            }
        },
    }
}

export default administrationData